module.exports = __webpack_public_path__ + "img/src/components/ListGridCoverPhoto/large_no_image.jpeg?5389cfdd";